export default __webpack_public_path__ + "static/media/React_Icon.20adfb35.png";